export default __webpack_public_path__ + "static/media/logoExtended.cca15189.png";